export const ADD_NEW_BANK = 'Add New Bank';
